<div class="slider-filter-backdrop" [ngClass]="{'slider-filter-backdrop-open': isOpen}"></div>
<div [ngClass]="{'overlay': isOpen}" (click)="closeDetails()"></div>
<div class="slider-filter-content" [ngClass]="{'slider-open': isOpen}">
    <div #stickyFilterHeader class="slider-filter-header">
        <div class="label">

            AI Insights
        </div>
        <div class="close-button" (click)="closeDetails()">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </div>
    </div>

    <div class="slider-filter-body">
        <!-- Loading State for AI Insights -->
        <div class="ai-loading-container" *ngIf="isLoading">
            <div class="ai-loading-content">
                <div class="loading-spinner">
                    <svg class="spinner" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                    </svg>
                </div>
                <div class="loading-text">
                    <h3><ng-icon name="tablerBrain"></ng-icon> Fetching AI Insights...</h3>
                    <p>Our AI is analyzing the match details. This may take a while.</p>
                    <p class="loading-subtext">Please hold on, you can continue using the app while we process...</p>
                </div>
            </div>
        </div>

        <!-- Match Score Content (shown when not loading) -->
        <div class="match-score-container" *ngIf="!isLoading && details && details.length > 0; else noResult">
            <ng-container *ngFor="let detail of details">
                <!-- Left Section: Candidate Match Score -->
                <div class="left-section">
                    <!-- Complete Insights View -->
                    <ng-container *ngIf="hasCompleteInsights">
                        <div class="section-title">

                            <h3 *ngIf="['suggested-candidates','talent-pool','job-applicants'].includes(pageFrom)">Candidate Match Score</h3>
                            <h3 *ngIf="['jobsApplied','suggestedJobs','candidate-applied'].includes(pageFrom)">Job Match Score</h3>

                            <p class="subtitle" *ngIf="hasQuantitativeCriteria">This score is calculated based on the criteria listed below</p>
                            <p class="subtitle" *ngIf="!hasQuantitativeCriteria">AI-generated insights for this match</p>
                        </div>

                        <!-- Match Criteria Table (only show if we have percentage data) -->
                        <div class="criteria-table" *ngIf="hasQuantitativeCriteria">
                            <div class="criteria-row" *ngFor="let criteria of detail?.criteria">
                                <div class="criteria-label">
                                    <!-- <ng-icon name="tablerChevronDown" class="criteria-icon"></ng-icon> -->
                                    <span>{{ criteria.label }}</span>
                                </div>
                                <div class="criteria-progress">
                                    <div class="progress-bar-container">
                                        <div class="progress-bar" [style.width.%]="criteria.percentage"
                                            [style.background-color]="getProgressColor(criteria.percentage)">
                                        </div>
                                    </div>
                                    <span class="percentage-text" [style.color]="getProgressTextColor(criteria.percentage)">
                                        {{ criteria.percentage }} %
                                    </span>
                                </div>
                                <div class="criteria-expand">
                                    <ng-icon name="tablerChevronDown" class="expand-icon disabled"></ng-icon>
                                </div>
                            </div>
                        </div>

                        <!-- Overall Assessment Section -->
                        <div class="assessment-section">
                            <div class="assessment-header">
                                <ng-icon name="tablerStar" class="assessment-icon"></ng-icon>
                                <h4>Overall Assessment</h4>
                            </div>
                            <p class="assessment-subtitle" *ngIf="detail.reason">
                                {{detail.reason}}
                            </p>

                            <!-- Strengths -->
                            <div class="assessment-item strengths" *ngIf="detail.strengths && detail.strengths.length > 0">
                                <div class="item-header">
                                    <ng-icon name="tablerCircleCheck" class="success-icon"></ng-icon>
                                    <span class="item-label">Strengths / Fit for Role</span>
                                    <div class="feedback-buttons">
                                        <div class="feedback-btn-wrapper">
                                            <button class="feedback-btn agree-btn"
                                                [class.selected]="detail?.strengthsFeedback === 'AGREE'"
                                                (click)="updateFeedback('STRENGTH','AGREE',detail)">
                                                <ng-icon name="tablerThumbUp"></ng-icon>
                                                Agree
                                                <span class="btn-spinner" *ngIf="savingStrength === 'AGREE'"></span>
                                                <ng-icon name="tablerCircleCheck" class="chosen-check"
                                                    *ngIf="detail?.strengthsFeedback === 'AGREE' && savingStrength !== 'AGREE'"></ng-icon>
                                            </button>
                                            <div class="feedback-tooltip" *ngIf="showTooltip['strength-agree']" [@fadeInOut]>
                                                <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                            </div>
                                        </div>
                                        <div class="feedback-btn-wrapper">
                                            <button class="feedback-btn disagree-btn"
                                                [class.selected]="detail?.strengthsFeedback === 'DISAGREE'"
                                                (click)="toggleDisagreeInput('strength', detail)">
                                                <ng-icon name="tablerThumbDown"></ng-icon>
                                                Disagree
                                                <span class="btn-spinner" *ngIf="savingStrength === 'DISAGREE'"></span>
                                                <ng-icon name="tablerCircleCheck" class="chosen-check"
                                                    *ngIf="detail?.strengthsFeedback === 'DISAGREE' && savingStrength !== 'DISAGREE'"></ng-icon>
                                            </button>
                                            <!-- Disagree Reason Input -->
                                            <div class="feedback-input-tooltip" *ngIf="showDisagreeInput['strength']" [@fadeInOut]>
                                                <div class="tooltip-header">
                                                    <span>Please provide a reason</span>
                                                    <ng-icon name="tablerX" class="close-icon" (click)="closeDisagreeInput('strength')"></ng-icon>
                                                </div>
                                                <textarea
                                                    #strengthDisagreeInput
                                                    [(ngModel)]="disagreeReason['strength']"
                                                    placeholder="Enter reason for improving the analysis..."
                                                    rows="3"
                                                    maxlength="500"
                                                    (click)="$event.stopPropagation()"></textarea>
                                                <div class="tooltip-footer">
                                                    <span class="char-count">{{ disagreeReason['strength']?.length || 0 }}/500</span>
                                                    <button class="submit-btn"
                                                        (click)="submitDisagree('STRENGTH', 'DISAGREE', detail, 'strength')"
                                                        [disabled]="!disagreeReason['strength'] || disagreeReason['strength'].trim() === ''">
                                                        <ng-icon name="tablerSend"></ng-icon> Submit
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- Success Tooltip -->
                                            <div class="feedback-tooltip" *ngIf="showTooltip['strength-disagree']" [@fadeInOut]>
                                                <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ul class="item-list">
                                    <li *ngFor="let strength of detail.strengths">
                                        <ng-icon name="tablerCheck" class="check-icon"></ng-icon>
                                        {{ strength }}
                                    </li>
                                </ul>
                            </div>

                            <!-- Potential Concerns / Weaknesses -->
                            <div class="assessment-item concerns" *ngIf="detail.weaknesses && detail.weaknesses.length > 0">
                                <div class="item-header">
                                    <ng-icon name="tablerAlertTriangle" class="warning-icon"></ng-icon>
                                    <span class="item-label">Potential Concerns</span>
                                    <div class="feedback-buttons">
                                        <div class="feedback-btn-wrapper">
                                            <button class="feedback-btn agree-btn"
                                                [class.selected]="detail?.weaknessesFeedback === 'AGREE'"
                                                (click)="updateFeedback('WEAKNESS','AGREE',detail)">
                                                <ng-icon name="tablerThumbUp"></ng-icon>
                                                Agree
                                                <span class="btn-spinner" *ngIf="savingWeakness === 'AGREE'"></span>
                                                <ng-icon name="tablerCircleCheck" class="chosen-check"
                                                    *ngIf="detail?.weaknessesFeedback === 'AGREE' && savingWeakness !== 'AGREE'"></ng-icon>
                                            </button>
                                            <div class="feedback-tooltip" *ngIf="showTooltip['weakness-agree']" [@fadeInOut]>
                                                <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                            </div>
                                        </div>
                                        <div class="feedback-btn-wrapper">
                                            <button class="feedback-btn disagree-btn"
                                                [class.selected]="detail?.weaknessesFeedback === 'DISAGREE'"
                                                (click)="toggleDisagreeInput('weakness', detail)">
                                                <ng-icon name="tablerThumbDown"></ng-icon>
                                                Disagree
                                                <span class="btn-spinner" *ngIf="savingWeakness === 'DISAGREE'"></span>
                                                <ng-icon name="tablerCircleCheck" class="chosen-check"
                                                    *ngIf="detail?.weaknessesFeedback === 'DISAGREE' && savingWeakness !== 'DISAGREE'"></ng-icon>
                                            </button>
                                            <!-- Disagree Reason Input -->
                                            <div class="feedback-input-tooltip" *ngIf="showDisagreeInput['weakness']" [@fadeInOut]>
                                                <div class="tooltip-header">
                                                    <span>Please provide a reason</span>
                                                    <ng-icon name="tablerX" class="close-icon" (click)="closeDisagreeInput('weakness')"></ng-icon>
                                                </div>
                                                <textarea
                                                    #weaknessDisagreeInput
                                                    [(ngModel)]="disagreeReason['weakness']"
                                                    placeholder="Enter reason for improving the analysis..."
                                                    rows="3"
                                                    maxlength="500"
                                                    (click)="$event.stopPropagation()"></textarea>
                                                <div class="tooltip-footer">
                                                    <span class="char-count">{{ disagreeReason['weakness']?.length || 0 }}/500</span>
                                                    <button class="submit-btn"
                                                        (click)="submitDisagree('WEAKNESS', 'DISAGREE', detail, 'weakness')"
                                                        [disabled]="!disagreeReason['weakness'] || disagreeReason['weakness'].trim() === ''">
                                                        <ng-icon name="tablerSend"></ng-icon> Submit
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- Success Tooltip -->
                                            <div class="feedback-tooltip" *ngIf="showTooltip['weakness-disagree']" [@fadeInOut]>
                                                <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ul class="item-list">
                                    <li *ngFor="let weakness of detail.weaknesses">
                                        <ng-icon name="tablerX" class="times-icon"></ng-icon>
                                        {{ weakness }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Simplified View for Incomplete Data -->
                    <ng-container *ngIf="!hasCompleteInsights">
                        <div class="section-title">
                            <h3>Match Score Summary</h3>
                            <p class="subtitle">Basic match score available</p>
                        </div>

                        <div class="incomplete-data-notice">
                            <div class="notice-icon">
                                <ng-icon name="tablerInfoCircle"></ng-icon>
                            </div>
                            <div class="notice-content">
                                <h4>Detailed Insights Not Available</h4>
                                <p>The AI analysis for this match is still being processed or the detailed breakdown is not yet available.</p>
                                <p class="notice-subtext">You can see the overall match score on the right. Detailed criteria breakdown will appear here once the analysis is complete.</p>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <!-- Right Section: Job Match Score with Circle -->
                <div class="right-section">
                    <div class="section-title">
                        
                        <h3 *ngIf="['suggested-candidates','talent-pool','job-applicants'].includes(pageFrom)">Candidate Match Score</h3>
                        <h3 *ngIf="['jobsApplied','suggestedJobs','candidate-applied'].includes(pageFrom)">Job Match Score</h3>

                        <ng-icon name="tablerInfoCircle" class="info-icon"></ng-icon>
                    </div>

                    <!-- Circular Progress -->
                    <div class="circular-progress">
                        <svg viewBox="0 0 200 200" class="circular-svg">
                            <circle cx="100" cy="100" r="85" class="circle-bg"></circle>
                            <circle cx="100" cy="100" r="85" class="circle-progress"
                                [style.stroke-dashoffset]="534 - (534 * detail.score / 100)"></circle>
                        </svg>
                        <div class="score-content">
                            <div class="score-number">{{ detail.score }}</div>
                            <div class="score-label">{{ getScoreMatchLabel(detail.score) }}</div>
                        </div>
                    </div>

                    <!-- Accuracy Feedback -->
                    <div class="accuracy-section">
                        <p class="accuracy-question">Is the Match Score accurate?</p>
                        <div class="accuracy-buttons">
                            <div class="accuracy-btn-wrapper">
                                <button class="accuracy-btn accurate-btn"
                                    [class.selected]="detail?.overAllFeedback === 'ACCURATE'"
                                    (click)="selectAccuracy('accurate', detail)">
                                    <ng-icon name="tablerCheck"></ng-icon>
                                    Accurate
                                    <span class="btn-spinner" *ngIf="savingOverall === 'ACCURATE'"></span>
                                    <ng-icon name="tablerCircleCheck" class="chosen-check"
                                        *ngIf="detail?.overAllFeedback === 'ACCURATE' && savingOverall !== 'ACCURATE'"></ng-icon>
                                </button>
                                <!-- Thank you tooltip for accurate -->
                                <div class="feedback-tooltip accuracy-tooltip" *ngIf="showTooltip['accuracy-accurate']" [@fadeInOut]>
                                    <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                </div>
                            </div>
                            <div class="accuracy-btn-wrapper">
                                <button class="accuracy-btn somewhat-btn"
                                    [class.selected]="detail?.overAllFeedback === 'SOMEWHAT_ACCURATE'"
                                    (click)="selectAccuracy('somewhat', detail)">
                                    <ng-icon name="tablerAdjustments"></ng-icon>
                                    Somewhat Accurate
                                    <span class="btn-spinner" *ngIf="savingOverall === 'SOMEWHAT_ACCURATE'"></span>
                                    <ng-icon name="tablerCircleCheck" class="chosen-check"
                                        *ngIf="detail?.overAllFeedback === 'SOMEWHAT_ACCURATE' && savingOverall !== 'SOMEWHAT_ACCURATE'"></ng-icon>
                                </button>
                                <!-- Thank you tooltip for somewhat -->
                                <div class="feedback-tooltip accuracy-tooltip" *ngIf="showTooltip['accuracy-somewhat']" [@fadeInOut]>
                                    <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                </div>
                            </div>
                            <div class="accuracy-btn-wrapper">
                                <button class="accuracy-btn not-accurate-btn"
                                    [class.selected]="detail?.overAllFeedback === 'NOT_ACCURATE'"
                                    (click)="selectAccuracy('not-accurate', detail)">
                                    <ng-icon name="tablerX"></ng-icon>
                                    Not Accurate
                                    <span class="btn-spinner" *ngIf="savingOverall === 'NOT_ACCURATE'"></span>
                                    <ng-icon name="tablerCircleCheck" class="chosen-check"
                                        *ngIf="detail?.overAllFeedback === 'NOT_ACCURATE' && savingOverall !== 'NOT_ACCURATE'"></ng-icon>
                                </button>
                                <!-- Thank you tooltip for not-accurate -->
                                <div class="feedback-tooltip accuracy-tooltip" *ngIf="showTooltip['accuracy-not-accurate']" [@fadeInOut]>
                                    <ng-icon name="tablerCircleCheck"></ng-icon> Thank you for your feedback!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="slider-filter-footer">
        <div class="slider-filter-footer-items">
            <button class="btn btn-default" (click)="closeDetails()">Close</button>
        </div>
    </div>
</div>

<ng-template #noResult>
    <app-nodata-found *ngIf="!isLoading" [title]="['No data found!']"></app-nodata-found>
</ng-template>